/** In-memory cache for GET /api/v1/users/me/school (per access token). */

let cache = {
  token: null,
  school: undefined,
  inflight: null,
};

export function clearMySchoolCache() {
  cache = { token: null, school: undefined, inflight: null };
}

export function setMySchoolCache(token, school) {
  if (!token) return;
  cache = { token, school: school ?? null, inflight: null };
}

export function getMySchoolCache(token) {
  if (!token || cache.token !== token || cache.school === undefined) return undefined;
  return cache.school;
}

/**
 * Dedupes concurrent requests; returns cached value when available.
 * @param {string} token
 * @param {() => Promise<unknown>} fetcher
 * @param {{ refresh?: boolean }} [options]
 */
export async function getMySchoolCached(token, fetcher, options = {}) {
  if (!token) {
    clearMySchoolCache();
    return null;
  }

  if (options.refresh) {
    if (cache.token === token) {
      cache.school = undefined;
      cache.inflight = null;
    }
  }

  if (cache.token === token && cache.school !== undefined && !cache.inflight) {
    return cache.school;
  }

  if (cache.token === token && cache.inflight) {
    return cache.inflight;
  }

  cache.token = token;
  cache.inflight = fetcher()
    .then((school) => {
      cache.school = school ?? null;
      cache.inflight = null;
      return cache.school;
    })
    .catch((err) => {
      cache.inflight = null;
      throw err;
    });

  return cache.inflight;
}

export const MY_SCHOOL_UPDATED_EVENT = 'my_school_updated';

export function notifyMySchoolUpdated(school) {
  window.dispatchEvent(new CustomEvent(MY_SCHOOL_UPDATED_EVENT, { detail: school }));
}
